<template>
  <form class="form-inline float-right">
    <div class="input-group">
      <span class="input-group-btn">
        <button class="btn btn-primary" type="button">任务名</button>
      </span>
      <input type="text" class="form-control" v-on:keydown.enter.prevent="doSearch" v-model="task_name">
    </div>
  </form>
</template>

<script>
import URLMixin from '@/mixins/url'

function doSearch (event) {
  let query = {
    name: this.task_name
  }
  if (this.task_name) {
    this.$route.query['name'] = this.task_name
  }

  this.$emit('refresh-tasks', query)
}

export default {
  name: 'tasks-search',
  data () {
    return {
      task_name: ''
    }
  },
  mixins: [URLMixin],
  methods: {
    doSearch
  },
  created () {
  }
}
</script>

